import React, { Component } from "react";

const EnsaCard = ({
    title,
    width,
    marginBottom,
    children
}) => {
    require("./Ensa.css");
    return (
        <div className="card-section" style={{ width: width + '%', marginBottom: marginBottom}}>
            <div className="content">
                <div className="title">
                    <h1>{title}</h1>
                </div>
                {children}
            </div>
        </div>
    );
}

export default EnsaCard;